<!-- ================管理端-推荐书目====================-->
<template>
    <div class="admin-create-container">
        <div class="admin-head-container">
            <div class="admin-left-head-container" @click="backList">
                <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#377f7f" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
            </div>
            <div class="admin-right-head-container">书目详情</div>
        </div>
        <div class="create-content-container">
            <div class="book-base-info-container">
                <div class="book-part1-l">
                    <div class="book-info-item-auto" v-show="bookForm.bookVideo">
                        <span class="item-span">导读视频：</span>
                    </div>
                    <!-- 导读视频  -->
                    <div class="book-video-container" v-show="bookForm.bookVideo">
                        <video id="videoElement"
                               :poster="bookForm.bookVideo + '?x-oss-process=video/snapshot,t_1,m_fast'" preload="none"
                               controls="controls" style="width: 75%;height: 100%;"
                               controlsList="nodownload"
                               :src="bookForm.bookVideo"></video>
                    </div>
                    <div class="book-info-item-auto">
                        <span class="item-span">书籍名称：</span>{{bookForm.bookName}}
                    </div>
                    <div class="book-info-item-auto">
                        <span class="item-span">所属主题：</span>{{bookForm.bookItemName}}
                    </div>
                    <div class="book-info-item-auto">
                        <span class="item-span">学段年级：</span>{{bookForm.periodName}}•{{bookForm.bookGradeName}}
                    </div>
                    <div class="book-info-item-auto">
                        <span class="item-span">作者：</span>{{bookForm.bookAuthor}}
                    </div>
                    <div class="book-info-item-auto">
                        <span class="item-span">出版时间：</span>{{ timestampDate(bookForm.publishTime) }}
                    </div>
                    <div class="book-info-item-auto">
                        <span class="item-span">书籍简介：</span>
                    </div>
                    <div class="book-info-item-auto-80" title="书籍简介" style="white-space: pre-wrap;">
                        {{bookForm.bookIntroduction}}
                    </div>
                    <div class="book-info-item-auto" v-if="bookForm.bookReason">
                        <span class="item-span">推荐理由：</span>
                    </div>
                    <div class="book-info-item-auto-80" v-if="bookForm.bookReason" title="推荐理由" style="white-space: pre-wrap;">
                        {{bookForm.bookReason}}
                    </div>
                    <div class="book-info-item-auto">
                        <span class="item-span">书籍附件：</span>
                    </div>
                    <div class="b-file-info-container">
                        <div class="b-file-list">
                            <div class="b-file-item" v-for="item in fileList" :key="item">
                                <div class="b-file-title">{{item.fileName}}</div>
                                <div class="b-file-view" title="预览" v-if="!judgeIsPPT(item.fileType)">
                                    <el-image @click="handleFIleStatus(item.status)" class="b-file-icon" style="margin-top: 5px"
                                              :src="require('@/assets/file/file_view.png')"
                                              :preview-src-list="gainFileImgList(item.imgUrl,item.pages)">
                                    </el-image>
                                </div>
                                <div class="b-file-view" title="播放" v-if="judgeIsPPT(item.fileType)">
                                    <el-image @click="viewPPTFile(item.fileUrl)" class="ppt-file-icon" style="margin-top: 5px"
                                              :src="require('@/assets/file/ppt_play.png')">
                                    </el-image>
                                </div>
                                <div class="b-file-download" title="下载">
                                    <img class="b-file-icon" @click="downloadFile(item)" style="margin-top: 3px" src="../../../assets/file/file_download.png" alt="">
                                </div>
                            </div>
                            <div v-if="fileList.length===0" class="data-empty">
                                <div class="empty-icon"><img src="../../../assets/image/data_empty.png" alt="" /></div>
                                <div class="empty-title">暂无附件</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="book-part1-r">
                    <div class="book-info-item-auto">
                        <span class="item-span">书目封面：</span>
                    </div>
                    <div class="book-base-info-cover">
                        <img class="img-100"  :src="bookForm.bookCover" alt="">
                    </div>
                    <!-- 评论区-->
                    <div class="comment-container">
                        <div class="comment-title-box">
                            评论区
                        </div>
                        <div class="comment-input-container">
                            <el-input
                              type="textarea"
                              @focus="focusInput"
                              resize="none"
                              placeholder="请输入内容"
                              v-model="discussWordContent"
                              autofocus></el-input>
                        </div>
                        <div class="comment-btn-box">
                            <div class="comment-limit">
                                <el-upload class="discuss-uploader"
                                           :action="serviceUrl+'/businessservice/book/uploadFile'"
                                           :show-file-list="false"
                                           :on-success="handleUploadImageSuccess"
                                           :headers="{ token }"
                                           accept=".png,.jpeg,.jpg"
                                           :before-upload="beforeImageUpload">
                                    <img class="icon-upload-img" alt="上传图片" src="../../../assets/image/upload_img1.png">
                                </el-upload>
                            </div>
                            <div class="sub-comment-limit" @click="submitDiscuss">
                                发表
                            </div>

                        </div>
                        <!--  评论内容 -->
                        <div class="comment-show-container">
                            <div class="b-discuss-one" v-for="item in discussList">
                                <div class="b-discuss-user-avatar">
                                    <img class="b-discuss-user-avatar-img" alt="无" @error="onImageError" :src="item.avatar">
                                </div>
                                <div class="b-discuss-user-content">
                                    <div class="b-user-info">
                                        <div class="b-flex-item b-user-true-name">{{item.createUserName}}</div>
                                        <div class="b-flex-item b-content-time">{{timestampToTime(item.createTime)}}</div>
                                    </div>
                                    <div class="b-content-info" v-if="item.discussType===1">
                                        {{item.content}}
                                    </div>
                                    <div class="b-img-info" v-if="item.discussType===2">
                                        <el-image alt="" :src="item.imgContent"
                                                  :preview-src-list="item.imgList" ></el-image>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="discussList.length===0" class="data-empty">
                            <div class="empty-icon"><img src="../../../assets/image/data_empty.png" /></div>
                            <div class="empty-title">暂无数据</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>
<script>
import {serviceUrl} from "@/utils/global";
import {infoBook} from "@/api/admin/book"
import {timestampDate, timestampToTime} from "@/utils/date";
import {downloadFile} from "@/utils/download";

export default {
    components: {},
    name: "bookDetail",
    data() {
        return {
            serviceUrl,
            token: this.$storage.get("token"),
            bookId:'',
            bookForm:{},  //数据
            timestampToTime,
            timestampDate,
            //评论区
            discussType:1, //研讨内容类型：1-文字 2-图片
            discussWordContent:'',
            wordContent: '',//文字评论
            imgContent: '',//图片评论
            discussList:[],
            fileList:[],
        }
    },
    computed: {},
    watch: {},
    created() {
        if (this.$route.query.bookId) {
            this.bookId = this.$route.query.bookId
            this.queryBookInfo()
        }
    },
    mounted() {

    },
    methods: {
        backList(){
            this.$router.push({
                path: "/book",
            });
        },
        queryBookInfo(){
            infoBook({ bookId: this.bookId }).then(res => {
                if (res.data.code === 1) {
                    this.bookForm = res.data.data;
                    this.fileList = this.bookForm.fileList;
                }else {
                    this.$message.error("操作失败")
                }
            });
        },
        /*============文件===========*/
        viewFile(file){},
        viewPPTFile(fileUrl){
            const openUrl = 'https://ow365.cn/?i=36735&ssl=1&furl=' +fileUrl;
            window.open(openUrl, '_blank')
        },
        judgeIsPPT(fileType){
            if (!fileType){
                return false;
            }
            return fileType.toLowerCase().includes("ppt");
            // return false;
        },
        downloadFile(item){
            downloadFile(item.fileUrl, item.fileName)
        },
        handleFIleStatus(status){
            if (status === 1) {
            }else {
                this.$message.info("文件正在处理，请稍后刷新预览")
            }
        },
        gainFileImgList(baseUrl,page,){
            const list = [];
            for (let i = 1; i <=page ; i++) {
                list.push(baseUrl+'/' + i+'.png?'+new Date());
            }
            return list;
        },
    },
}
</script>
<style>
.avatar-uploader .avatar {
    height: 260px;
    width: 185px;
    display: block;
    object-fit: cover;
}
.avatar-uploader /deep/ .el-upload {
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
}
.avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
}
.el-icon.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    height: 260px;
    width: 185px;
    text-align: center;
}

.book-base-info-container{
    width: 100%;
    height: auto;
    padding-bottom: 10px;
    display: flex;
}
.book-part1-l{
    width: calc(100% - 220px);
    height: 100%;
    padding-right: 20px;
    box-sizing: border-box;
}
.book-info-item-auto{
    width: 100%;
    height: auto;
    line-height: 25px;
    display: flex;
    font-size: 15px;
    margin-top: 5px;
}
.book-info-item-auto-80{
    width: 95%;
    height: auto;
    line-height: 25px;
    display: flex;
    font-size: 15px;
    margin-top: 5px;
}
.book-part1-r{
    width: 220px;
    height: 100%;
}
.book-base-info-cover{
    width: 210px;
    height: 297px;
    box-sizing: border-box;
    img{
        width: 100%;
        height: 100%;
    }
}
.item-span{
    font-weight: bold;
    color: #377f7f;
}
.book-video-container{
    width: 100%;
    height: auto;
}
.comment-container{
    width: 100%;
    height: 200px;
    padding: 20px 10px 0 0;
    box-sizing: border-box;
}
.comment-title-box{
    height: 20px;
    line-height: 20px;
    background-color: rgba(255,255,255,.9);
    color: #377f7f;
    font-weight: bold;
    border-left: 4px solid #377f7f;
    font-size: 16px;
    margin-bottom: 10px;
    text-indent: 2px;
}
.comment-input-container{
    display: inline-block;
    width: 210px;
    >>>.el-textarea__inner::placeholder{
        font-size: 12px;
    }
    >>>.el-textarea__inner{
        font-size: 12px;
    }
}

.comment-btn-box{
    display: flex;
    //padding: 0 6px;
    box-sizing: border-box;
    margin-top: 10px;
}
.comment-limit{
    width: 26px;
    height: 26px;
    background-color: #377f7f;
    font-size: 12px;
    color: #999aaa;
    border-radius: 13px;
    margin-right: 10px;
    .icon-upload-img{
        width: 20px;
        height: 20px;
        margin: 3px 0 0 3px;
    }
}

.sub-comment-limit{
    width: 56px;
    height: 24px;
    margin-left: 120px;
    background-color: #377f7f;
    color: #fff;
    border-radius: 12px;
    text-align: center;
    font-size: 12px;
    cursor: pointer;
    line-height: 24px;
}

.comment-show-container{
    width: 100%;
    height: auto;
    padding-top: 10px;
}
.b-discuss-one{
    display: flex;
    padding-bottom: 10px;
    background-color: rgba(255,255,255,.8);
    box-sizing: border-box;

}
.b-discuss-user-avatar{
    width: 40px;
}

.b-discuss-user-avatar-img{
    width: 30px!important;
    height: 30px;
    border-radius: 15px!important;
}
.b-discuss-user-content{
    width: 160px;
    font-size: 14px;
}
.b-user-info{
    display: flex;
    height: 25px;
    padding-right: 10px;
    box-sizing: border-box;
}
.b-user-true-name{
    font-size: 12px;
    height: 25px;
    line-height: 25px;
    text-align: left;
    margin-right: 10px;
    align-content: flex-start;
}
.b-content-time{
    line-height: 25px;
    font-size: 12px;
    align-content: flex-end;
}
.b-content-info{
    padding: 2px 10px 0 0;
    font-size: 11px;
    color: #525B68;
    line-height: 16px;
    word-wrap:break-word;
    word-break:break-all;

}
.b-img-info{
    padding: 2px 10px 0 0;
    display: flex;
    width: 160px;
    flex-wrap: wrap;
    .el-image{
        width: 120px;
        height: auto;
        margin: 0 5px 5px 0;
    }
}

.b-file-info-container{
    width: 100%;
    height: auto;
}
.b-file-list{
    width: calc(100% - 60px);
    height: auto;
}
.b-file-item{
    display: flex;
    height: 30px;
    width: 100%;
    box-sizing: border-box;
}
.b-file-item:hover{
    color: #377f7f!important;
    font-weight: bold;
}
.b-file-title{
    width: calc(100% - 60px);
    height: 100%;
    font-size: 15px;
    line-height: 30px;
    cursor: pointer;
    padding-left: 20px;
    box-sizing: border-box;
}
.b-file-view{
    width: 30px;
    height: 100%;
}
.b-file-download{
    width: 30px;
    height: 100%;
}
.b-file-icon{
    width: 20px;
    height: 20px;
    cursor: pointer;
}
.ppt-file-icon{
    width: 20px;
    height: 18px;
    cursor: pointer;
}
@media (max-width: 1024px) {
    .book-base-info-container { flex-direction: column; }
    .book-part1-l { width: 100%; padding-right: 0; }
    .book-part1-r { width: 100%; margin-top: 20px; }
    .book-base-info-cover { width: 180px; height: 254px; }
    .comment-input-container { width: 100%; }
    .sub-comment-limit { margin-left: auto; }
    .b-discuss-user-content { width: calc(100% - 40px); }
}
</style>
